var map = {
	"./Accordion": 97,
	"./Accordion.js": 97,
	"./Acknowledgements": 246,
	"./Acknowledgements.js": 246,
	"./Appendix": 252,
	"./Appendix.js": 252,
	"./Bookmarks": 150,
	"./Bookmarks.js": 150,
	"./Callout": 74,
	"./Callout.js": 74,
	"./Carousel": 98,
	"./Carousel.js": 98,
	"./Chapter": 253,
	"./Chapter.js": 253,
	"./Composite": 23,
	"./Composite.js": 23,
	"./Cover": 254,
	"./Cover.js": 254,
	"./Figure": 99,
	"./Figure.js": 99,
	"./Foreword": 255,
	"./Foreword.js": 255,
	"./Glossary": 256,
	"./Glossary.js": 256,
	"./IFrame": 100,
	"./IFrame.js": 100,
	"./Index": 257,
	"./Index.js": 257,
	"./Information": 258,
	"./Information.js": 258,
	"./Instructions": 259,
	"./Instructions.js": 259,
	"./Introduction": 260,
	"./Introduction.js": 260,
	"./List": 101,
	"./List.js": 101,
	"./ListItem": 147,
	"./ListItem.js": 147,
	"./Media": 102,
	"./Media.js": 102,
	"./MediaClip": 71,
	"./MediaClip.js": 71,
	"./Modal": 103,
	"./Modal.js": 103,
	"./Paragraph": 128,
	"./Paragraph.js": 128,
	"./Picture": 57,
	"./Picture.js": 57,
	"./Preface": 261,
	"./Preface.js": 261,
	"./Prologue": 262,
	"./Prologue.js": 262,
	"./References": 263,
	"./References.js": 263,
	"./Section": 148,
	"./Section.js": 148,
	"./SectionBreak": 31,
	"./SectionBreak.js": 31,
	"./SectionI": 264,
	"./SectionI.js": 264,
	"./SectionIi": 265,
	"./SectionIi.js": 265,
	"./SectionIii": 266,
	"./SectionIii.js": 266,
	"./Sources": 267,
	"./Sources.js": 267,
	"./Supplement": 268,
	"./Supplement.js": 268,
	"./Table": 104,
	"./Table.js": 104,
	"./TableOfContents": 152,
	"./TableOfContents.js": 152,
	"./TableOfContentsEntry": 28,
	"./TableOfContentsEntry.js": 28,
	"./Tabs": 105,
	"./Tabs.js": 105,
	"./Thumbnail": 73,
	"./Thumbnail.js": 73,
	"./Title": 149,
	"./Title.js": 149,
	"./Words": 70,
	"./Words.js": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/BookElements ^\.\/.*$
// module id = 649
// module chunks = 0